import React from 'react';
import './loader.scss';

interface LoaderProps {
  children?: React.ReactNode;
  isShow?: boolean;
  isStretched?: boolean;
  transparent?: boolean;
  smallLoader?: boolean;
  centeredLoader?: boolean;
  className?: string;
  spinnerStyles?: React.CSSProperties;
  miniLoader?: boolean;
  dataTestId?: string;
  style?: React.CSSProperties;
}

export class Loader extends React.PureComponent<LoaderProps> {
  static defaultProps: LoaderProps = {
    isShow: false,
    isStretched: false,
    transparent: false,
    smallLoader: false,
    centeredLoader: false,
    className: '',
    spinnerStyles: {},
    dataTestId: 'loader',
  };

  render() {
    const {
      isShow,
      transparent,
      smallLoader,
      miniLoader,
      className,
      spinnerStyles,
      centeredLoader,
      isStretched,
      dataTestId,
      ...rest
    } = this.props;

    let IE = false;

    if (typeof navigator !== 'undefined') {
      if (
        navigator.appName === 'Microsoft Internet Explorer' ||
        !!(
          navigator.userAgent.match(/Trident/) ||
          navigator.userAgent.match(/rv:11/)
        )
      ) {
        IE = true;
      }
    }

    return (
      <div
        className={`loader ${className} ${isShow ? '_show' : ''} ${
          transparent ? '_transparent' : ''
        } ${isStretched ? '_stretched' : ''}`}
        {...rest}
        data-testid={`${dataTestId}-loader`}
      >
        {isShow && (
          <div
            style={spinnerStyles}
            className={`loader__spinner ${smallLoader ? '_small' : ''} ${
              centeredLoader ? '_centered' : ''
            } ${miniLoader ? '_mini' : ''}`}
          >
            <img
              className={`loader__img ${IE ? 'loader__rotate' : ''}`}
              src="/assets/loader.svg"
              alt="loader"
            />
          </div>
        )}
        {this.props.children}
      </div>
    );
  }
}
